import instaclustrComponent from "./Components";
import layoutResizing from "../utils/layoutResizing";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        // Breakpoint references
        let sm = 576,
            md = 768,
            lg = 992,
            xl = 1200;

        // Viewport width helper function
        function viewport() {
            let e = window,
                a = 'inner';
            if (!('innerWidth' in window)) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width: e[ a + 'Width' ], height : e[ a + 'Height'] };
        }

        let vpWidth       = viewport().width;

        // Check if the user is accessing the page on a mobile device
        let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        // Adjust height of masked image column to match content
        let $heroComponent  = $('.component.component-hero-banner-2024');
        let $mainHeight     = $heroComponent[0].offsetHeight;
        let $heroContent    = $('.component.component-hero-banner-2024 .hero-content');
        let $height= $heroContent[0].offsetHeight;
        let $imageContainer = $('.hero-image.image-mask-image');

        if (vpWidth > md) {
            $imageContainer.css({'height': $height});
        }

        // Adjust text box and component height as needed by screen size
        let $textBox   = $('.component.component-hero-banner-2024 .text-box');

        function adjustTextBox() {
            let $boxHeight = $textBox[0].offsetHeight;
            let offsetMd = ($boxHeight - 80) * -1;
            let offsetSm = ($boxHeight * .25);
            if (vpWidth > md) {
                // text box is absolute position
                $textBox.css({'bottom' : offsetMd});
            } else {
                // text box is relative position; adjust component height
                $heroComponent.css({
                    'height' : $mainHeight - (offsetSm + 80)
                });
            }
        }

        if ($textBox.length > 0) {
            adjustTextBox();
        }

        // Adjust layout after window resize
        layoutResizing();

    }
}
